// const PostExam = ({ exam, id }) => {
//   if (!exam) return null;

//   return (
//     <div
//       style={{
//         width: "100%",
//         // padding: "0 40px",
//         height: "650px",
//         overflow: "hidden",
//       }}
//     >
//       <iframe
//         title={id}
//         src={`https://exams.loonlog.ca/questions?fullscreen=true&${decodeURIComponent(
//           exam
//         )}`}
//         width="100%"
//         height="650px"
//         style={{
//           border: "none",
//           borderRadius: "12px",
//           overflow: "hidden",
//           // pointerEvents: interactive ? "auto" : "none",
//         }}
//         allow="fullscreen"
//       />
//     </div>
//   );
// };

// export default PostExam;

import React, { useState, useRef, useEffect, memo } from "react";

const PostExam = memo(
  ({ exam, id, lazy = true }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);
    const [isVisible, setIsVisible] = useState(!lazy);
    const iframeRef = useRef(null);
    const containerRef = useRef(null);

    // Intersection Observer for lazy loading
    useEffect(() => {
      if (!lazy) return;

      const observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            setIsVisible(true);
            observer.disconnect();
          }
        },
        { threshold: 0.1 }
      );

      if (containerRef.current) {
        observer.observe(containerRef.current);
      }

      return () => observer.disconnect();
    }, [lazy]);

    // Optimize query string construction
    const constructUrl = () => {
      try {
        const baseUrl = "https://exams.loonlog.ca/questions";
        const params = new URLSearchParams({
          fullscreen: "true",
          ...Object.fromEntries(new URLSearchParams(decodeURIComponent(exam))),
        });
        return `${baseUrl}?${params.toString()}`;
      } catch (error) {
        console.error("Error constructing iframe URL:", error);
        setHasError(true);
        return "";
      }
    };

    const handleLoad = () => {
      setIsLoading(false);
    };

    const handleError = () => {
      setIsLoading(false);
      setHasError(true);
    };

    // Preload the iframe content
    useEffect(() => {
      if (isVisible && !lazy) {
        const link = document.createElement("link");
        link.rel = "preload";
        link.href = constructUrl();
        link.as = "document";
        document.head.appendChild(link);

        return () => document.head.removeChild(link);
      }
    }, [isVisible, exam, lazy]);

    if (!exam) return null;

    const iframeSrc = constructUrl();

    return (
      <div
        ref={containerRef}
        style={{
          width: "100%",
          minHeight: "650px",
          overflow: "hidden",
          position: "relative",
        }}
      >
        {/* Loading State */}
        {isLoading && isVisible && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#f5f5f5",
              borderRadius: "12px",
              zIndex: 1,
            }}
          >
            <div>Loading exam...</div>
          </div>
        )}

        {/* Error State */}
        {hasError && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#ffe6e6",
              borderRadius: "12px",
              color: "#d32f2f",
            }}
          >
            <div>Failed to load exam. Please try again.</div>
          </div>
        )}

        {/* Iframe */}
        {isVisible && iframeSrc && (
          <iframe
            ref={iframeRef}
            title={`exam-${id}`}
            src={iframeSrc}
            width="100%"
            height="650px"
            loading="lazy"
            onLoad={handleLoad}
            onError={handleError}
            style={{
              border: "none",
              borderRadius: "12px",
              overflow: "hidden",
              opacity: isLoading ? 0 : 1,
              transition: "opacity 0.3s ease",
            }}
            allow="fullscreen"
            referrerPolicy="strict-origin-when-cross-origin"
            sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
          />
        )}
      </div>
    );
  },
  (prevProps, nextProps) => {
    return prevProps.exam === nextProps.exam && prevProps.id === nextProps.id;
  }
);

export default PostExam;
